import React from "react";
import * as R from "ramda";
import { compose, renderNothing, branch, toClass } from "recompose";
import CKEditor from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";

import CloudinaryAdapter from "./CloudinaryAdapter";
import Tags from "./Tags";

import styled from "styled-components/macro";

const ContentEditor = styled.div`
  .editor {
    position: relative;
  }

  .ck.ck-editor__editable_inline {
    overflow: auto;
    height: 240px;
    padding: 0 var(--ck-spacing-standard);
    border: 1px solid #d9d9d9;
  }

  .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline {
    width: 21cm;
    height: 29.7cm;
    padding: 1.5cm 1.5cm 1.5cm 2.4cm;
    border: 1px hsl(0, 0%, 82.7%) solid;
    border-radius: var(--ck-border-radius);
    background: white;
    box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.1);
    margin: 0 auto;
  }

  .ck.ck-toolbar.ck-reset_all.ck-rounded-corners {
    z-index: 1;
    box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.2);
    border-bottom: 1px solid var(--ck-color-toolbar-border);
    border: 1px solid #c4c4c4;
    border-radius: var(--ck-border-radius);
    background: #f2f2f2;
    box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.1);
    margin: 0 auto;
  }

  .image.image-style-align-left {
    margin-left: 0px;
    float: left;
  }
`;

const Disabled = styled.div`
  position: absolute;
  background: #f7f9fa;
  height: 100%;
  width: 100%;
  z-index: 1;
  opacity: 0.6;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const JobOfferEditor = ({ t, onChange, value, isDisabled }) => {
  return (
    <ContentEditor>
      <div className="editor">
        {isDisabled && <Disabled />}
        <CKEditor
          onInit={editor => {
            let WrapperEditor = document.createElement("div");
            WrapperEditor.style.padding = "27px";
            WrapperEditor.style.background = "#fafafa";
            WrapperEditor.style.margin = "0 auto";
            WrapperEditor.style.height = "450px";
            WrapperEditor.style.overflowY = "scroll";
            WrapperEditor.style.border = "1px solid #c4c4c4";

            editor.ui
              .getEditableElement()
              .parentElement.insertBefore(
                WrapperEditor,
                editor.ui.getEditableElement()
              );

            WrapperEditor.append(editor.ui.getEditableElement());
            WrapperEditor.parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              WrapperEditor
            );
            editor.editing.view.focus();
            editor.plugins.get("FileRepository").createUploadAdapter = loader =>
              new CloudinaryAdapter(loader);
            console.log(editor);
          }}
          onChange={(event, editor) => {
            onChange(editor.getData());
          }}
          editor={DecoupledEditor}
          data={value}
        />
      </div>
      <Tags t={t} isDisabled={isDisabled} />
    </ContentEditor>
  );
};

export default compose(
  toClass,
  // Fix bug -> prevent initializing empty content in first render
  branch(R.propSatisfies(R.isNil, "value"), renderNothing)
)(JobOfferEditor);
